<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入公式内容进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
					<el-select v-model="questionModel" placeholder="程序模式" clearable style="margin-right: 10px" @change="questionModelChange()">
					    <el-option
					      v-for="item in questionModels"
					      :key="item.kqmId"
					      :label="item.kqmName"
					      :value="item.kqmId">
					    </el-option>	
					</el-select>
					<el-select v-model="computeModel" placeholder="公式类型" clearable style="margin-right: 10px" @change="computeModelChange()">
					    <el-option
					      v-for="item in kytypes"
							:key="item.key"
							:label="item.value"
							:value="item.key">
					    </el-option>
					</el-select>
<!-- 					<el-select v-model="dialecticCountModel" placeholder="所属辨证次数" clearable style="margin-right: 10px" @change="dialecticCountModelChange()">
					    <el-option
					      v-for="item in queryDialecticCountArr"
					      :key="item.key"
					      :label="item.value"
					      :value="item.key">
					    </el-option>
					</el-select> -->
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <!-- <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>
					<!-- <el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加公式
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
				<el-table-column
				        prop="kqmName"
				        label="所属程序模式"
				        align="center"
				        width="240">
				</el-table-column>
                <el-table-column
                        prop="kfName"
                        align="center"
                        label="公式编码"
                        width="240">
                </el-table-column>
				<el-table-column
				        prop="kfTypeStr"
				        align="center"
				        label="公式类型"
				        width="240">
				</el-table-column>
<!-- 				<el-table-column
				        prop="kfDialecticCount"
				        label="所属辨证次数"
				        align="center"
				        width="130">
						<template slot-scope="scope">
							<span>{{scope.row.kfDialecticCount}}</span>
						</template>
				</el-table-column> -->
                <!-- <el-table-column
                        prop="kfVal"
                        label="公式内容"
                        align="center"
                        width="280">
                </el-table-column> -->
                <el-table-column
                        prop="kfCreateTime"
                        width="180"
                        align="center"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        prop="kfAddUserName"
                        width="120"
                        align="center"
                        label="创建人">
                </el-table-column>
                <el-table-column
                        prop="kfUpdateTime"
                        width="180"
						align="center"
                        label="最新修改时间">
                </el-table-column>
                <el-table-column
                        prop="kfUpdateUserName"
                        width="120"
						align="center"
                        label="最新修改人">
                </el-table-column>
                <el-table-column
						align="center"
                        prop="kfIsEnableStr"
                        width="120"
                        label="题目状态">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        width="320"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
						:current-page.sync="page"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				v-loading="loading2"
				element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"
                width="80%">
            <div class="dialog-box">
                <el-form :model="kytFormula" :rules="rules" ref="empForm">
					<el-row>
						<el-col :span="8">
							<el-form-item label="程序模式" prop="kfQueModelid">
								<el-select v-model="kytFormula.kfQueModelid" placeholder="程序模式" clearable style="margin-right: 10px" @change="selectBelongQmChange">
									<el-option
									  v-for="item in questionModels"
									  :key="item.kqmId"
									  :label="item.kqmName"
									  :value="item.kqmId">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="复制的公式:" >
								<div style="display: flex;">
									<el-select v-model="copyFromQmId"  placeholder="选择程序模式" clearable style="margin-right: 10px" @change="selectQmChange">
										<el-option
										  v-for="item in totalQuestionModels"
										  :key="item.kqmId"
										  :label="item.kqmName"
										  :value="item.kqmId">
										</el-option>	
									</el-select>
									<el-select v-model="copyFromFmlId" placeholder="选择需要复制的公式" clearable style="margin-right: 10px" @change="selectFmlChange">
										<el-option
										  v-for="item in tempFormulas"
										  :key="item.kfId"
										  :label="item.kfName + ' ' + item.kfNameCn"
										  :value="item.kfId">
										</el-option>	
									</el-select>
								</div>

							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="名称：">
								<div class="input_box" style="width: 12.25rem;">
									<el-input v-model="kytFormula.childFormulas[kytFormula.childFormulas.length -1].kfcName"
									          placeholder="最终公式名称" disabled ></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="中文名称：">
								<div class="input_box" style="width: 12.25rem;">
									<el-input v-model="kytFormula.kfNameCn"
									          placeholder="请输入公式中文名称" maxlength="50" ></el-input>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="类型：">
								<div class="input_box" style="width: 12.25rem;">
									<el-select v-model="kytFormula.kfType" placeholder="请选择公式类型" size="medium"
											   style="margin-left: 5px;margin-right: 5px">
										<el-option
												v-for="item in kytypes"
												:key="item.key"
												:label="item.value"
												:value="item.key">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="文字表达：" style="margin-left: 8px;" >
								<div class="input_box" style="width: 12.25rem;">
									<el-input prefix-icon="el-icon-edit" v-model="kytFormula.kfExpress"
											  placeholder="请输入文字表达" maxlength="200" show-word-limit></el-input>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="执行顺序号：" prop="kfExecNo" >
								<div class="input_box" style="width: 8.25rem;">
									<el-input v-model="kytFormula.kfExecNo"
											  placeholder="公式执行顺序号" maxlength="3"></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="输出展示顺序号：" prop="kfExportNo" v-if="kytFormula.kfType != '1' && kytFormula.kfType != ''">
								<div class="input_box" style="width: 8.25rem;">
									<el-input v-model="kytFormula.kfExportNo"
											  placeholder="输出展示顺序号" maxlength="3"></el-input>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="隐形输出：" prop="kfIsImplicit" v-if="kytFormula.kfType != '1' && kytFormula.kfType != ''">
								<el-radio-group v-model="kytFormula.kfIsImplicit">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<div class="formula_warp" v-for="(formula,index) in kytFormula.childFormulas" :key="formula.kfcId">
						<div class="formula_tit">公式：</div>
						<div class="formula_body">
							<el-form-item label="" :prop="`childFormulas.${index}.kfcName`" :rules="rules.kfcName">
								<div class="input_box" style="width: 12.25rem;">
									<el-input prefix-icon="el-icon-edit" v-model="formula.kfcName"
									          placeholder="请输入公式名称" maxlength="10" show-word-limit></el-input>
								</div>
							</el-form-item>
							<div class="equal">=</div>
							<el-form-item label="" :prop="`childFormulas.${index}.kfcVal`" :rules="rules.kfcVal">
								<div class="input_box" style="width: 38.25rem;">
									<el-input prefix-icon="el-icon-edit" v-model="formula.kfcVal"
									          placeholder="请输入公式内容" maxlength="5000" show-word-limit></el-input>
								</div>
							</el-form-item>

						</div>
						<el-button type="primary" style="margin: 0;" v-show="index == 0" icon="el-icon-plus" circle @click="addOption(formula)"></el-button>
						<el-button type="primary" style="margin: 0;" v-show="index > 0" icon="el-icon-minus" circle @click="minusOption(formula)"></el-button>
						
					</div>
                    <el-row>
						<el-col :span="12">
						    <el-form-item label="公式状态：" prop="kfIsEnable">
						        <el-radio-group v-model="kytFormula.kfIsEnable">
						            <el-radio :label="0">启用</el-radio>
						            <el-radio :label="1">停用</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
    </div>
</template>

<script>
	import { Loading } from 'element-ui';
	import { v4 as uuidv4 } from 'uuid'
    export default {
        name: "Tenants",
        data() {
            return {
				dialecticCountModel:'',
				queryDialecticCountArr:[],
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
				loading2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				optionIndex:[
					'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
				],
				kytypes:[
					{
						key:'1',value:'计算公式'
					},
					{
						key:'2',value:'输出结果'
					},
					{
						key:'3',value:'图形输出'
					},
					{
						key:'4',value:'音乐单元'
					}
				],
                kytFormula: {
					kfId:'',
					kfName:'',
					kfNameCn:'',
					kfExecNo:'',
					kfExportNo:'',
					kfIsImplicit:'',
					kfType:'',
					kfExpress:'',
					childFormulas:[
						{
							kfcId:'',
							kfcName:'',
							kfcVal:'',
							kfcLabel:'',
							kfcIndex:''
						}
					],
					kfIsEnable:'',
					kfQueModelid:'',
					kfDialecticCount:''
                },
                rules: {
					/* kfDialecticCount: [{required: true, message: '请选择所属辨证次数', trigger: 'blur'}], */
					kfQueModelid: [{required: true, message: '请选择程序模式', trigger: 'blur'}],
					kfcName: [{required: true, message: '请输入公式名称', trigger: 'blur'}],
                    kfcVal: [{required: true, message: '请输入公式内容', trigger: 'blur'}],
					kfIsEnable: [{required: true, message: '请选择公式状态', trigger: 'blur'}],
					kfExecNo: [{required: true, message: '请输入执行顺序号', trigger: 'blur'}],
					kfIsImplicit: [{required: true, message: '请选择是否为隐形输出', trigger: 'blur'}],
					kfExportNo: [{required: true, message: '请输入输出展示顺序号', trigger: 'blur'}]
                },
				questionModels:[],
				questionModel:'',
				computeModel:'',
				totalQuestionModels:[],
				tempFormulas:[],
				copyFromFmlId:'',
				copyFromQmId:'',
				dialecticCountArr:[]
            }
        },
        mounted() {
			this.initDialecticCountArr();
            this.initEmps();
            this.initData();
			this.totalModels()
        },
        methods: {
			initDialecticCountArr(){
				let url = '/question/basic/getFormulaDialecticCount?modelId='+this.questionModel;
				this.getRequest(url).then(resp => {
				    if (resp.status == 200) {
						this.queryDialecticCountArr = []
						var maxCount = parseInt(resp.obj)
						for (var i = 1;i<=maxCount;i++){
							this.queryDialecticCountArr.push({
								key:i,
								value: '第'+i+'次辨证'
							})
						}
				    }
				});
			},
			dialecticCountModelChange(){
				this.page = 1;
				this.initEmps();
			},
			selectBelongQmChange(e){
				this.getQuestionModelInfo(e)
			},
			getQuestionModelInfo(QmId){
				let url = '/questionModel/basic/getQuestionModelInfo/'+QmId;
				this.getRequest(url).then(resp => {
				    if (resp.status == 200) {
						//this.tempQustions = resp.obj.kqmDialecticCount
						this.dialecticCountArr = []
						var kqmDialecticCount = parseInt(resp.obj.kqmDialecticCount)
						for (var i = 1;i <= kqmDialecticCount;i++) {
							this.dialecticCountArr.push(i+'')
						}
				    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
				});
			},
			totalModels(){
				let url = '/question/basic/getQuestionModelsList';
				this.getRequest(url).then(resp => {
				    if (resp) {
				        this.totalQuestionModels = resp.obj;
				    }
				});
			},
			computeModelChange(){
				this.page = 1;
				this.initEmps();
			},
			questionModelChange(){
				this.page = 1;
				this.dialecticCountModel = '';
				this.initDialecticCountArr();
				this.initEmps();
			},
			addOption(){
				const uuid = uuidv4()
				var opIndex = this.$util.getCurrentTime();
				console.log(opIndex)
				this.kytFormula.childFormulas.push(
					{
						kfcId:uuid,
						kfcName:'',
						kfcVal:'',
						kfcLabel:'',
						kfcIndex:opIndex
					}
				)
			},
			minusOption(item){
				console.log(item)
				var curoptions = this.kytFormula.childFormulas.filter(e => {
					return e.kfcId != item.kfcId 
				})
				console.log(curoptions)
				this.kytFormula.childFormulas = curoptions
			},
            emptyEmp() {
				const uuid = uuidv4()
				var opIndex = this.$util.getCurrentTime();
				console.log(opIndex)
				this.kytFormula.kfQueModelid = '';
				this.kytFormula.kfId = '';
				this.kytFormula.kfType = '';
				this.kytFormula.kfName = '';
				this.kytFormula.kfNameCn = '';
				this.kytFormula.kfExecNo = '';
				this.kytFormula.kfExportNo = '';
				this.kytFormula.kfIsImplicit = '';
				this.kytFormula.kfIsEnable = '';
				this.kytFormula.kfExpress = '';
				this.kytFormula.kfDialecticCount = '';
				this.kytFormula.childFormulas = [{
					kfcId:uuid,
					kfcName:'',
					kfcVal:'',
					kfcLabel:'',
					kfcIndex:opIndex
                }];
				this.copyFromFmlId = '';
				this.copyFromQmId = '';
				
            },
            showEditEmpView(data) {
                this.title = '编辑公式信息';
                this.emp = data;
                this.dialogVisible = true;
				this.queryFormulaInfo(data);
				this.$refs['empForm'].clearValidate(); 
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/formula/basic/del/" + data.kfId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			selectQmChange(e){
				console.log(e)
				this.copyFromFmlId = ''
				this.tempFormulas = []
				if(e){
					this.getFormulasListByQmId(e)	
				}
				
			},
			selectFmlChange(e){
				console.log(e)
				this.queryFormulaInfoForCopy({kfId : e})
			},
			getFormulasListByQmId(QmId){
				this.loading2 = true;
				let url = '/formula/basic/getFormulasListByQmId/'+QmId;
				this.getRequest(url).then(resp => {
				    this.loading2 = false;
				    if (resp.status == 200) {
						this.tempFormulas = resp.obj
				    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
				});
			},
			queryFormulaInfoForCopy(data){
				this.loading2 = true;
				let url = '/formula/basic/getFormulaInfoById/'+data.kfId;
				this.getRequest(url).then(resp => {
				    this.loading2 = false;
				    if (resp.status == 200) {
						this.kytFormula.kfType = resp.obj.kfType;
						/* this.kytFormula.kfExecNo = resp.obj.kfExecNo; */
						this.kytFormula.kfNameCn = resp.obj.kfNameCn;
						this.kytFormula.childFormulas = resp.obj.childFormulas;
						this.kytFormula.kfExpress = resp.obj.kfExpress;
						this.kytFormula.kfIsEnable = parseInt(resp.obj.kfIsEnable);
				    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
				});
			},
			queryFormulaInfo(data){
				this.loading2 = true;
				let url = '/formula/basic/getFormulaInfoById/'+data.kfId;
				this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp.status == 200) {
						this.kytFormula.kfId = resp.obj.kfId;
						this.kytFormula.kfType = resp.obj.kfType;
						this.kytFormula.kfExecNo = resp.obj.kfExecNo;
						this.kytFormula.kfExportNo = resp.obj.kfExportNo;
						this.kytFormula.kfIsImplicit = parseInt( resp.obj.kfIsImplicit );
						this.kytFormula.kfExpress = resp.obj.kfExpress;
						this.kytFormula.kfNameCn = resp.obj.kfNameCn;
						this.kytFormula.childFormulas = resp.obj.childFormulas;
						this.kytFormula.kfIsEnable = parseInt(resp.obj.kfIsEnable);
						this.kytFormula.kfQueModelid = resp.obj.kfQueModelid;
						this.kytFormula.kfDialecticCount = resp.obj.kfDialecticCount;
						this.getQuestionModelInfo(this.kytFormula.kfQueModelid)
                    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
                });
			},
            doAddEmp() {
				let loadingInstance = Loading.service({ fullscreen: true });
				this.kytFormula.kfName = this.kytFormula.childFormulas[this.kytFormula.childFormulas.length -1].kfcName
                if (this.kytFormula.kfId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/formula/basic/update", this.kytFormula).then(resp => {
								this.$nextTick(() => {
								  loadingInstance.close();
								});
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }else{
							this.$nextTick(() => {
							  loadingInstance.close();
							});
						}
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/formula/basic/add", this.kytFormula).then(resp => {
								this.$nextTick(() => {
								  loadingInstance.close();
								});
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }else{
							this.$nextTick(() => {
							  loadingInstance.close();
							});
						}
                    });
                }
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				this.getQuestionModelsList()
            },
			getQuestionModelsList(){
				this.questionModels = []
				let url = '/question/basic/getQuestionModelsList';
				this.getRequest(url).then(resp => {
			        if (resp.status == 200) {
						this.questionModels = resp.obj;
			        }else{
			
					}
			    });
			},
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加公式';
                this.dialogVisible = true;
				this.$refs['empForm'].clearValidate(); 
            },
            initEmps(type) {
                this.loading = true;
                let url = '/formula/basic/getFormulasList?page=' + this.page + '&size=' + this.size;
                url += "&kfVal=" + this.keyword;
				url += "&dialecticCountModel=" + this.dialecticCountModel;
				url += "&questionModel=" + this.questionModel
				url += "&computeModel=" + this.computeModel;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	/deep/ .el-form-item__label {
		width: auto !important;
	}
	/deep/ .el-form-item__content {
		flex:1;
	}
	.formula_warp {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 1.125rem;
		.formula_tit {
			min-width: 6.125rem;
			padding: 0 12px 0 0;
			text-align: right;
			box-sizing: border-box;
		}
		.formula_body {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin-right: 0.625rem;
			.el-form-item {
				margin-bottom: 0;
			}
			.equal {
				margin: 0 0.625rem;
			}
		}
	}
	.el-form-item {
		display: flex;
		.input_box {
			//width: 28.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	.options_warp {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		.option_item {
			margin-bottom: 0.625rem;
		}
	}
	::v-deep .dialog-box {
		.el-form-item__label {
			width: 5.125rem;
		}
	}

</style>
